var _defs, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _line9, _path, _line0, _path2, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 240",
    width: 320,
    height: 240,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 24,
    height: 24,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 0 L 0 0 0 24",
    stroke: "#fff",
    strokeOpacity: 0.17,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gm",
    cx: "50%",
    cy: "50%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#fff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gmask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#gm)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5082ef",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#5082ef",
    stopOpacity: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5082ef",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ag",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 5,
    markerHeight: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#5a5a66"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ab",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 5,
    markerHeight: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#5082ef"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ain",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 3.75,
    markerHeight: 3.75,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#6AC6E4"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "aout",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 3.75,
    markerHeight: 3.75,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#E1814C"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#g)",
    mask: "url(#gmask)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 115.2,
    y1: 115.7,
    x2: 96,
    y2: 150.1,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 150.1,
    x2: 62.3,
    y2: 113.3,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 62.3,
    y1: 113.3,
    x2: 87.7,
    y2: 92,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 87.7,
    y1: 92,
    x2: 115.2,
    y2: 115.7,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 254,
    y1: 113.5,
    x2: 229.9,
    y2: 150.8,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 229.9,
    y1: 150.8,
    x2: 203.8,
    y2: 113.7,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 203.8,
    y1: 113.7,
    x2: 231.7,
    y2: 92.3,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 231.7,
    y1: 92.3,
    x2: 254,
    y2: 113.5,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.2,
    cy: 115.7,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 150.1,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.3,
    cy: 113.3,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.7,
    cy: 92,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 113.5,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.9,
    cy: 150.8,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.8,
    cy: 113.7,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.7,
    cy: 92.3,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 118,
    r: 50,
    fill: "url(#glow)"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 125.7,
    y1: 116.2,
    x2: 134,
    y2: 116.7,
    stroke: "#6AC6E4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 117.1 L133.9 119.7 L134.2 113.7 Z",
    fill: "#6AC6E4"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 178.4,
    y1: 116.2,
    x2: 185.9,
    y2: 115.5,
    stroke: "#E1814C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.4 114.7 L186.2 118.4 L185.6 112.5 Z",
    fill: "#E1814C"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 118,
    r: 15,
    fill: "#5082ef",
    stroke: "#5082ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutual);
export default __webpack_public_path__ + "static/media/mutual.8bc7db8a4547db29e5b0aa3baff3a386.svg";
export { ForwardRef as ReactComponent };